module.exports = __webpack_public_path__ + "img/pr-3.f45abb9a.png";